import { useWebsitePageListQuery } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';

export function useWebsitePageList() {
  const { eventHandle } = useEventInfo();

  const { data, loading, error, refetch } = useWebsitePageListQuery({
    variables: { eventHandle: eventHandle ?? '', admin: false },
    batchMode: 'off',
    ssr: true,
  });

  const pages = data?.eventByName?.pages ?? [];
  return {
    pages,
    loading,
    error,
    refetch,
  };
}
